import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider, useAuth } from './context/AuthContext'
import Login from './pages/Login'
import Dashboard from './pages/Dashboard'
import LinkAccount from './pages/LinkAccount'
import Attendance from './pages/Attendance'
import DailyPlan from './pages/DailyPlan'
import Assessment from './pages/Assessment'
import Fees from './pages/Fees'

function Protected({ children }) {
  const { session, loading } = useAuth()
  if (loading) return <div style={{ textAlign: 'center', margin: '2rem' }}>جاري التحميل...</div>
  if (!session) return <Navigate to="/login" replace />
  return children
}

export default function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/link-account"
          element={(
            <Protected>
              <LinkAccount />
            </Protected>
          )}
        />
        <Route
          path="/attendance"
          element={(
            <Protected>
              <Attendance />
            </Protected>
          )}
        />
        <Route
          path="/daily-plan"
          element={(
            <Protected>
              <DailyPlan />
            </Protected>
          )}
        />
        <Route
          path="/assessment"
          element={(
            <Protected>
              <Assessment />
            </Protected>
          )}
        />
        <Route
          path="/fees"
          element={(
            <Protected>
              <Fees />
            </Protected>
          )}
        />
        <Route
          path="/"
          element={(
            <Protected>
              <Dashboard />
            </Protected>
          )}
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AuthProvider>
  )
}
